import script from "./AdminNews.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminNews.vue?vue&type=script&setup=true&lang=js"

import "./AdminNews.vue?vue&type=style&index=0&id=d5bacf86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5bacf86"]])

export default __exports__